import * as htmlToImage from 'html-to-image'

export function captureImage(fileName, code, index, disease) {
  const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL
  const saveImageApiUrl = `${BASE_URL}/saveimage`
  let broadcastChannel = new BroadcastChannel('map_channel')

  htmlToImage
    .toPng(document.querySelector('#map'), {
      // width: 1300,
      // height: 900,
      // canvasHeight: 893,
      // canvasWidth: 1595,
    })
    .then((imageData) => {
      let imgObject = {
        name: `${disease.toUpperCase()}/${fileName.toUpperCase()}.png`,
        base64Content: imageData,
      }

      //code to download the image
      let link = document.createElement('a')
      link.href = imageData
      link.download = `${fileName.toUpperCase()}.png`
      link.click()

      // API call
      fetch(saveImageApiUrl, {
        method: 'post',
        body: JSON.stringify(imgObject),
        headers: {
          'Content-Type': 'text/plain',
          requester: JSON.stringify(window.localStorage.getItem('requester')),
        },
        credentials: 'include',
      })
        .then((res) => {
          if (!res.ok) throw new Error('Upload failed')
          return res.json()
        })
        .then((result) => {
          if (result) {
            broadcastChannel.postMessage({
              processed: index + 1,
              status: true,
              file: imgObject.name.split('/').at(-1),
              message: `${imgObject.name
                .split('/')
                .at(-1)
                .toLowerCase()} saved successfully!`,
            })

            if (index === 51) {
              broadcastChannel.postMessage({
                processed: index + 1,
                status: true,
                message: `Image generation completed successfully!`,
              })
            }
            setTimeout(() => {
              window.close()
            }, 1000)
          } else {
            throw new Error('Image generation failed!')
          }
        })
        .catch((err) => {
          console.log('Error', err)
          broadcastChannel.postMessage({
            processed: index + 1,
            status: false,
            file: imgObject.name.split('/').at(-1),
            message: `Failed to save ${imgObject.name
              .split('/')
              .at(-1)
              .toLowerCase()}!`,
          })
        })
    })
    .catch((err) => {
      console.log('error', err)
      broadcastChannel.postMessage({
        processed: index + 1,
        status: false,
        message: `Some error occurred!`,
      })
    })
}
